import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./screens/Login";
import Main from "./screens/Main";

import { isLoggedIn } from "./js/utils";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <Routes>
      <Route path="/main" element={isLoggedIn() ? <Main /> : <Login />} />
      <Route
        path="/:screenId/:params"
        element={isLoggedIn() ? <Main /> : <Login />}
      />
      <Route path="/:screenId" element={isLoggedIn() ? <Main /> : <Login />} />
      <Route path="/" exact element={<Login />} />
    </Routes>
  </Router>
);

reportWebVitals();
